// import sensors from 'sa-sdk-javascript';

// 判断是否正式环境
export function isMain() {
  let root = process.env.VUE_APP_ROOT;
  return root == 'main';
}

// 判断是否本地环境
export function isLocal() {
	return process.env.NODE_ENV === 'development';
}

// 判断是否微信打开
export function isWeixin() {
	return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
}

export function cache(key, value) {
	if(value === undefined) {
		return window.localStorage[key];
	}

	window.localStorage[key] = value;
}

// 储存storage
export function setStorage(path, key, val){
	let content = window.localStorage[path],
	obj = {};
	if(content){
		obj = JSON.parse(content);
		obj[key] = val;
	}else{
		obj[key] = val;
	}
	window.localStorage[path] = JSON.stringify(obj);
}
// 获取storage
export function getStorage(path, key){
	let content = window.localStorage[path];
	if(!content){
		return false
	}
	let obj = JSON.parse(content);
	return obj[key]
}
// 删除storage
export function deleteStorage(path){
	localStorage.removeItem(path);
}
// 储存sessionStorage
export function setSessionStorage(path, key, val){
	let content = window.sessionStorage[path],
	obj = {};
	if(content){
		obj = JSON.parse(content);
		obj[key] = val;
	}else{
		obj[key] = val;
	}
	window.sessionStorage[path] = JSON.stringify(obj);
}
// 获取sessionStorage
export function getSessionStorage(path, key){
	let content = window.sessionStorage[path];
	if(!content){
		return false
	}
	let obj = JSON.parse(content);
	return obj[key]
}
// 删除SessionStorage
export function deleteSessionStorage(path){
	sessionStorage.removeItem(path);
}
// 获取token键名
export function getTokenKey() {
	return isMain() ? 'main_token' : 'test_token';
}

export function getTppTokenKey() {
	return isMain() ? 'main_tpp_token' : 'test_tpp_token';
}

// 设置token
export function setStorageToken(token = ''){
	let url = window.location.href;
	if(!token) {
		token = queryString(url, 'token');
	}
	
	if(token){
		let is_wx_token = token.length === 32;
		let token_key = is_wx_token ? getTokenKey() : getTppTokenKey();
		window.localStorage[token_key] = token;
		if(is_wx_token) {
			window.localStorage[getTppTokenKey()] = '';
		}
	}
}
// 获取token
export function getStorageToken(){
	let token_key = getTokenKey();
	let tpp_token_key = getTppTokenKey();
	
	let storage = window.localStorage[token_key];
	let tpp_token = window.localStorage[tpp_token_key];

	if(!isWeixin() && tpp_token) {
		return tpp_token;
	}

	return (storage && storage.length === 32 ) ? storage : false;
}

// 判断测试地址与正式地址
export function getCursorUrl(){
	if(isMain()){
		return 'https://coach.xjy.cn/'
	}
	return 'https://coachline.xjy.cn/'
}

// 做自己节购票-域名
export function getBeMySelfUrl(){
	if(isMain()){
		return 'https://open.xjy.cn/api/'
	}
	return 'https://open.xjy.cn/dev/'
}

// 判断测试地址与正式地址的头部和底部
export function getCursorHash(){
	if(isMain()){
		return 'https://api.xjy.cn/tools/'
	}
	return 'https://api.xjy.cn/develops/'
}
// 跳转微信授权登陆
export function goAuthLogin(info, authorizer_appid, scope = 'snsapi_base'){
	let getParam = function(key) {
		let url = location.href.replace('#/', '/').split('#')[0];
		let value = '';
		let reg = new RegExp('/' + key + '/([^/\\.]+)');
		if(reg.test(url)) {
			value = reg.exec(url)[1];
		}
		reg = new RegExp('[\\?&]' + key + '=([^\\?&]+)');
		if(reg.test(url)) {
			value = reg.exec(url)[1];
		}
		return decodeURIComponent(value);
	};

	authorizer_appid = authorizer_appid || getParam('authorizer_appid');

	let url = window.location.href;
	let appid = '';
	let client_id = '';

	if(isMain()){
		appid = 'wx662871f607e1bfa4';
		client_id = 'xjyqh00d1598';
	} else {
		appid = 'wx88240a827734b090';
		client_id = 'xjyqh00cu5641';
	}

	let component_appid = 'wx411f5431d0b20b67';
	let chengzi_appid = 'wxf1a71334ade996a0';

	window.localStorage['unionid'] = null;

	let base_url = isMain() ? 'https://open.xjy.cn/api/weixin/oauth?component_appid=' : 'https://open.xjy.cn/dev/weixin/oauth?appid=';
	let redirect_url = base_url + component_appid + '&client_id=' + client_id + '&from_appid=' + appid + '&scope=' + scope + '&redirect_url=' + encodeURIComponent(url) + '&authorizer_appid=' + chengzi_appid;

	if(authorizer_appid) {
		redirect_url += (',' + authorizer_appid);
	}

	// return console.log(info, authorizer_appid, redirect_url);

	// 授权地址
	location.href = redirect_url;
}
// 正则截取参数
export function queryString( url, key ){

	let qr = url.split('?');

	if(qr.length === 1){
		return false
	}

	let json = {},
	queryArr = qr[1].split('&');
	for(let arg of queryArr){
		let old = arg.split('=');
		let key = old[0],
		val = old[1];
		json[key] = val;
	}

	return json[key]

}

/*删除地址栏中，指定的参数名*/
export function delParam(paramKey) {
	var url = window.location.href;    //页面url
	var urlParam = window.location.search.substr(1);  //页面参数
	var beforeUrl = url.substr(0, url.indexOf("?"));  //页面主地址（参数之前地址）
	var nextUrl = "";
	var arr = new Array();
	if (urlParam != "") {
		var urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
		for (var i = 0; i < urlParamArr.length; i++) {
			var paramArr = urlParamArr[i].split("="); //将参数键，值拆开
			//如果键雨要删除的不一致，则加入到参数中
			if (paramArr[0] != paramKey) {
				arr.push(urlParamArr[i]);
			}
		}
	}
	if (arr.length > 0) {
		nextUrl = "?" + arr.join("&");
	}
	url = beforeUrl + nextUrl;
	return url;
}

// // 神测数据
// export function sensorsdata(callback){
// 	let qArg = isMain() ? 'project=default&token=1fb7fb650b53d7bb' : 'token=1fb7fb650b53d7bb&project=production';
	
// 	// (function(para) {
// 	//   let p = para.sdk_url, n = para.name, w = window, d = document, s = 'script',x = null,y = null;
// 	//   if(typeof(w['sensorsDataAnalytic201505']) !== 'undefined') {
// 	//       return false;
// 	//   }
// 	//   w['sensorsDataAnalytic201505'] = n;
// 	//   w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
// 	//   let ifs = ['track','quick','register','registerPage','registerOnce','trackSignup', 'trackAbtest', 'setProfile','setOnceProfile','appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify','login','logout','trackLink','clearAllRegister','getAppStatus'];
// 	//   for (let i = 0; i < ifs.length; i++) {
// 	//     w[n][ifs[i]] = w[n].call(null, ifs[i]);
// 	//   }
// 	//   if (!w[n]._t) {
// 	//     x = d.createElement(s), y = d.getElementsByTagName(s)[0];
// 	//     x.async = 1;
// 	//     x.src = p;
// 	//     x.setAttribute('charset','UTF-8');
// 	//     y.parentNode.insertBefore(x, y);
// 	//     w[n].para = para;
// 	//   }
// 	// })({
// 	//   sdk_url: 'https://static.sensorsdata.cn/sdk/1.13.2/sensorsdata.min.js',
// 	//   heatmap_url: 'https://static.sensorsdata.cn/sdk/1.13.2/heatmap.min.js',
// 	//   name: 'sensors',
// 	//   server_url: `https://xinjingying.datasink.sensorsdata.cn/sa?${qArg}`,
// 	//   heatmap: {},
// 	//   is_track_single_page: true
// 	// });
	
// 	sensors.init({
// 		server_url: `https://xinjingying.datasink.sensorsdata.cn/sa?${qArg}`,
// 		heatmap: {
// 			//是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
// 			//需要 JSSDK 版本号大于 1.7
// 			clickmap: 'default',
// 			//是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
// 			//需要 JSSDK 版本号大于 1.9.1
// 			scroll_notice_map: 'default'
// 		},
// 		is_track_single_page: true
// 	});

// 	window.sensors = sensors;

// 	if(callback) {
// 		callback();
// 	}
// }

// 解决对象同时指向同一个内存地址问题
export function deepCopy(o) {
	if (o instanceof Array) {  //先判断Array
		let n = [];
		for (let i = 0; i < o.length; ++i) {
			n[i] = deepCopy(o[i]);
		}
		return n;

	} else if (o instanceof Object) {
		let n = {}
		for (let i in o) {
			n[i] = deepCopy(o[i]);
		}
		return n;
	} else {
		return o;
	}
}
/*
 *@param: fmt格式,date时间
 *@return: fmt
 *@Description: 格式化时间
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2019-09-27 12:04:47
*/
// export function dateFormat(fmt, date) {
//     let ret;
//     let opt = {
//         "Y+": date.getFullYear().toString(),        // 年
//         "m+": (date.getMonth() + 1).toString(),     // 月
//         "d+": date.getDate().toString(),            // 日
//         "H+": date.getHours().toString(),           // 时
//         "M+": date.getMinutes().toString(),         // 分
//         "S+": date.getSeconds().toString()          // 秒
//         // 有其他格式化字符需求可以继续添加，必须转化成字符串
//     };
//     for (let k in opt) {
//         ret = new RegExp("(" + k + ")").exec(fmt);
//         if (ret) {
//             fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
//         };
//     };
//     return fmt;
// }

//value 格式为13位unix时间戳
//10位unix时间戳可通过value*1000转换为13位格式
export function dateFormat (fmt,date) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

export function padLeftZero (str) {
    return ('00' + str).substr(str.length);
};

// 转换阿拉伯数字为中文
let chnNumChar = ["零","一","二","三","四","五","六","七","八","九"];
let chnUnitSection = ["","万","亿","万亿","亿亿"];
let chnUnitChar = ["","十","百","千"];

export function SectionToChinese(section){
	let strIns = '', chnStr = '';
	let unitPos = 0;
	let zero = true;
	while(section > 0){
		let v = section % 10;
		if(v === 0){
			if(!zero){
				zero = true;
				chnStr = chnNumChar[v] + chnStr;
			}
		}else{
			zero = false;
			strIns = chnNumChar[v];
			strIns += chnUnitChar[unitPos];
			chnStr = strIns + chnStr;
		}
		unitPos++;
		section = Math.floor(section / 10);
	}
	return chnStr;
}

export function numberToChinese(num){  
		let unitPos = 0;  
		let strIns = '', chnStr = '';  
		let needZero = false;  
		
		if(num === 0){  
		return chnNumChar[0];  
		}  
		
		while(num > 0){  
		let section = num % 10000;  
		if(needZero){  
			chnStr = chnNumChar[0] + chnStr;  
		}  
		strIns = SectionToChinese(section);  
		strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];  
		chnStr = strIns + chnStr;  
		needZero = (section < 1000) && (section > 0);  
		num = Math.floor(num / 10000);  
		unitPos++;  
		}  
		
		return chnStr;  
}  

/*
 *@param: 
 *@return: flag?移动端：电脑端
 *@Description: 判断是移动端还是电脑端
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2020-03-30 13:50:22
*/
export function mobileOrWin(){
	//判断登录设备
	// let userAgentInfo = navigator.userAgent;
	// console.log(userAgentInfo);
	// let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
	let flag = (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))?true:false;
	// let v = 0;
	// for (v = 0; v < Agents.length; v++) {
	// 	if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = true; break; }
	// }
	
	return flag
}

/*
 *@param: obj 对象, key 比较的属性
 *@return: Aarray 数组
 *@Description: 比较对象值的大小并排序
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2020-08-3 13:50:22
*/
export function getSortArr(obj, key){
	var values = Object.values(obj);
	return values.sort((a,b)=>{
	  return b[key] -a[key];
	})
 }
/*
 *@param: 
 *@return: str 日期字符串
 *@Description: 获取当前日期
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2020-12-30 13:50:22
*/
export function  getNowFormatDate() {
	let date = new Date();
	let seperator1 = "-";
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	let strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	let currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}

export function strtotime(str) {
  return (new Date(str.replace(/-/g, '/'))).getTime() / 1000;
}

export function time() {
  return parseInt((new Date()).getTime() / 1000, 10);
}